import { faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useApi } from 'ApiHooks'
import { useBlockUI } from 'Context/BlockUIContext'
import React, { useState } from 'react'
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap'
import { tokenStorage } from 'TokenStorage'

interface PropsModalCambiarPassword {
    showModalCambiarPassword: boolean
    setShowModalCambiarPassword: (show: boolean) => void
}

const ModalCambiarPassword = ({ showModalCambiarPassword, setShowModalCambiarPassword }: PropsModalCambiarPassword) => {

    let api = useApi()
    const { showBlock, hideBlock, blocking } = useBlockUI()

    const [NewPassInput, setNewPassInput] = useState<string>('')
    const [NewPassInputConfirm, setNewPassInputConfirm] = useState<string>('')
    const [showMensajeExito, setShowMensajeExito] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const cambiarPassword = async () => {
        showBlock('Cambiando contraseña..')
        try {
            await api.cambiarPassword({
                usuario: tokenStorage.getUserName(),
                password: NewPassInput,
            }).then((response) => {
                if (response?.status === 200) {
                    setShowMensajeExito(true)
                }
            })
        } catch (error: any) {

        } finally {
            hideBlock()
        }
    }

    return (
        <>
            <Modal style={{
                backgroundColor: 'rgba(1,1,1,0.5)'
            }} show={showModalCambiarPassword} dialogClassName="modal-cambiar-password"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}>
                <Modal.Header style={{ backgroundColor: '#528bf5ff', padding: '1rem', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }} closeButton={false}>
                    <Modal.Title style={{ color: 'white' }}>Cambiar contraseña</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {showMensajeExito ? <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <FontAwesomeIcon color="#18b933ff" style={{ fontSize: 50, marginBottom: '5px', marginTop: '-20px' }} icon={faCheckCircle} />
                        <h5 className="text-center">Se ha cambiado su contraseña</h5>
                    </div> : <div className="mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <FontAwesomeIcon color="#e9d251ff" style={{ fontSize: 50, marginBottom: '5px', marginTop: '-20px' }} icon={faExclamationTriangle} />
                        <h5 className="text-center">Ingresar nueva contraseña</h5>
                    </div>}
                    <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {!showMensajeExito &&
                            <>
                                <Form.Group className="mb-4">
                                    <Form.Label className="font-weight-medium text-dark">Nueva contraseña</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text className="bg-white" style={{ borderColor: "#d1d5db", borderRight: "none" }}>
                                            <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <circle cx="12" cy="16" r="1" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                        </InputGroup.Text>
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Nueva contraseña"
                                            maxLength={15}
                                            minLength={6}
                                            value={NewPassInput}
                                            onChange={(e) => setNewPassInput(e.target.value)}
                                            style={{ height: "48px", borderColor: "#d1d5db", borderLeft: "none", borderRight: "none", fontSize: "16px" }}
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                borderColor: "#d1d5db",
                                                backgroundColor: "white",
                                                borderLeft: "none",
                                            }}
                                        >
                                            {showPassword ? (
                                                <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                    <path d="M1 1l22 22" />
                                                </svg>
                                            ) : (
                                                <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            )}
                                        </Button>
                                    </InputGroup>
                                    {NewPassInput.length > 0 && (NewPassInput.length < 6 || NewPassInput.length > 12) && (
                                        <small style={{ color: 'red' }}>
                                            La contraseña debe tener entre 6 y 15 caracteres.
                                        </small>
                                    )}
                                </Form.Group> <Form.Group className="mb-4">
                                    <Form.Label className="font-weight-medium text-dark">Repetir nueva contraseña</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text className="bg-white" style={{ borderColor: "#d1d5db", borderRight: "none" }}>
                                            <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <circle cx="12" cy="16" r="1" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                        </InputGroup.Text>
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Repetir nueva contraseña"
                                            maxLength={15}
                                            minLength={6}
                                            value={NewPassInputConfirm}
                                            onChange={(e) => setNewPassInputConfirm(e.target.value)}
                                            style={{ height: "48px", borderColor: "#d1d5db", borderLeft: "none", borderRight: "none", fontSize: "16px" }}
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                borderColor: "#d1d5db",
                                                backgroundColor: "white",
                                                borderLeft: "none",
                                            }}
                                        >
                                            {showPassword ? (
                                                <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                    <path d="M1 1l22 22" />
                                                </svg>
                                            ) : (
                                                <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                    <circle cx="12" cy="12" r="3" />
                                                </svg>
                                            )}
                                        </Button>
                                    </InputGroup>
                                    {NewPassInputConfirm.length > 0 && NewPassInput !== NewPassInputConfirm && (
                                        <small style={{ color: 'red' }}>
                                            Las contraseñas no coinciden.
                                        </small>
                                    )}
                                </Form.Group>
                                <br />
                            </>

                        }
                        {showMensajeExito ? <div>
                            <Button variant="success" onClick={() => {
                                setShowMensajeExito(false)
                                setNewPassInput('')
                                setNewPassInputConfirm('')
                                setShowModalCambiarPassword(false)
                            }}>
                                Aceptar
                            </Button>
                        </div> : <div>
                            <Button disabled={
                                blocking ||
                                NewPassInput.length < 6 ||
                                NewPassInput.length > 15 ||
                                NewPassInput !== NewPassInputConfirm
                            } onClick={() => cambiarPassword()}>Confirmar</Button>
                            <Button style={{ marginLeft: 10 }} variant="secondary" onClick={() => setShowModalCambiarPassword(false)}>
                                Cerrar
                            </Button>
                        </div>}
                        <br />
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCambiarPassword